<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :items="items">
        <template slot="title"> {{ $tc("autoriz.autoriz") }} </template>
      </Header>
      <v-col>
        <v-dialog v-model="showAdd" max-width="550px">
          <template v-slot:activator="{ on, attrs }">
            <div style="display: flex; justify-content: flex-end">
              <v-btn
                rounded
                class="btn-add mr-5"
                :title="$tc('editRegistrations.add')"
                v-bind="attrs"
                v-on="on"
                @click="dispatchComment"
              >
                {{ $tc("editRegistrations.add") }}
                <v-icon small class="ml-1" color="white" dark> fa-plus </v-icon>
              </v-btn>
            </div>
          </template>
          <CardDialog style="max-width: 600px">
            <template slot="title">
              {{
                titleForm
                  ? "Editar" + " " + "autorización"
                  : "Agregar" + " " + "autorización"
              }}
            </template>
            <template slot="body">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >

              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                style="margin: 10px"
              >
                <span style="color: grey">{{
                  $tc("rulesRegister.entyAndExit")
                }}</span>
                <div class="slider__day">
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-around;
                    "
                  >
                    <v-checkbox
                      :label="$tc('autoriz.previousDay')"
                      v-model="yesterday"
                      :disabled="laterDay"
                      style="margin-right: 20px"
                    />
                    <v-checkbox
                      :label="$tc('autoriz.laterDay')"
                      v-model="laterDay"
                      :disabled="yesterday"
                      style="margin-right: 30px"
                    />
                  </div>
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-around;
                    "
                  >
                    <date
                      :maxFrom="maxAct"
                      :minFrom="minAct"
                      v-if="!yesterday && !laterDay"
                    />
                    <date
                      :maxFrom="maxAnt"
                      :minFrom="minAnt"
                      :minTo="minToAnt"
                      :maxTo="maxToAnt"
                      v-if="yesterday"
                    />
                    <date
                      :maxTo="maxPos"
                      :minTo="minPos"
                      :maxFrom="maxFromPos"
                      :minFrom="minFromPos"
                      v-if="laterDay"
                    />
                  </div>
                </div>
                <v-autocomplete
                  :label="$tc('autoriz.coment')"
                  :items="getComent"
                  item-text="coment"
                  item-value="comentId"
                  outlined
                  v-model="coment"
                  required
                  :rules="rules"
                  class="mt-5"
                />
              </v-form>
              <div class="d-flex justify-space-between mx-2" style="width=100%">
                <v-btn class="bt-exit" @click="cancel()"
                  >{{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click.prevent="validate">
                  {{ $tc("editRegistrations.acept") }}</v-btn
                >
              </div>
            </template>
          </CardDialog>
        </v-dialog>
        <!------------------------------------------------------------------------------------------------>
        <v-dialog v-model="showDelete" max-width="350px">
          <CardDialog style="max-width: 350px; overflow: hidden">
            <template slot="title"> {{ $tc("autoriz.deleteAuth") }} </template>
            <template slot="body">
              <div
                class="d-flex justify-space-between mx-2 mt-2 mb-n4"
                style="width=100%"
              >
                <v-btn class="bt-exit" @click="cancel()"
                  >{{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click="deleteItem">
                  {{ $tc("editRegistrations.delete") }}</v-btn
                >
              </div>
            </template>
          </CardDialog>
        </v-dialog>

        <!------------------------------------------------------------------------------------------------>
        <DataTable
          :items="getAutoriz"
          :headers="headers"
          :loader="loader"
          :openEdit="openEdit"
          :openDelete="openDelete"
        />
      </v-col>
    </v-row>
    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Header from "./common/Header.vue";
import DataTable from "./common/DataTable.vue";
import autoriz from "../../../store/gestionTiempos/autoriz";
import CardDialog from "./common/CardDialog.vue";
import registrations from "../../../store/gestionTiempos/registrations";
import resultSettlementHours from "../../../store/gestionTiempos/resultSettlementHours";
import Date from "../Actions/DetalleDelDia/Date.vue";
export default {
  components: { Header, DataTable, CardDialog, Date },
  props: {
    items: Object,
  },
  data() {
    return {
      maxAct: "23:59",
      minAct: "00:00",
      minAnt: "12:00",
      maxAnt: "23:59",
      minToAnt: "00:00",
      maxToAnt: "11:59",
      maxFromPos: "23:59",
      minFromPos: "12:00",
      maxPos: "11:59",
      minPos: "00:00",
      yesterday: false,
      titleForm: false,
      laterDay: false,
      fromValue: null,
      toValue: null,
      data: {},
      coment: null,
      itemsToEdit: {},
      showDelete: false,
      valid: true,
      alertError: false,
      alertOk: false,
      textAlert: "",
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      itemsToDelete: {},
      error: false,
      alertValidate: "",
      showAdd: false,
      date: null,
      loader: false,
      headers: [
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          align: "center",
          sortable: true,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          align: "center",
          sortable: true,
        },
        {
          text: "Comentario",
          value: "coment",
          class: "primary secondary--text",
          align: "center",
          sortable: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          align: "center",
        },
      ],
    };
  },
  mounted() {
    this.loader = false;
    let date = this.items.date.split(/\D/);
    this.date = date.reverse().join("-");
    autoriz.commit("setDate", this.date);
  },
  computed: {
    getAutoriz() {
      return autoriz.state.autoriz;
    },
    getComent() {
      return autoriz.state.coment;
    },
    from: {
      get: function () {
        return registrations.state.dateFrom;
      },
      set: function (newDate) {
        return newDate;
      },
    },
    to: {
      get: function () {
        return registrations.state.dateTo;
      },
      set: function (newDate) {
        return newDate;
      },
    },
  },
  methods: {
    dispatchComment() {
      autoriz.dispatch("getComent").then(() => {
        this.openAdd();
      });
    },
    //se abre el formulario de agregar
    openAdd() {
      this.titleForm = false;
      this.yesterday = false;
      this.laterDay = false;

      let coment = autoriz.state.coment;
      this.coment = coment[0]?.comentId;
      setTimeout(() => {
        this.showAdd = true;
      }, 200);
    },

    //se abre el formulario de eliminar
    openDelete(item) {
      this.showDelete = true;
      this.itemsToDelete = {
        date: item.date,
        from: item.originalFrom,
        empId: item.empId,
      };
    },
    //se elimina
    deleteItem() {
      autoriz.commit("setDeleteItem", this.itemsToDelete);
      autoriz
        .dispatch("deleteAutoriz")
        .then((r) => {
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults");
          this.$store.dispatch("changeSchedule/getScheduleElement");
          this.textAlert = "Se eliminó correctamente";
          this.alertOk = true;
        })
        .catch(() => {
          this.textAlert = this.$tc("alert.errorDelete");
          this.alertError = true;
        });
      this.showDelete = false;
    },
    //se cancela el formulario
    cancel() {
      this.error = false;
      if (this.showAdd) {
        this.showAdd = false;

        let coment = autoriz.state.coment;
        (this.yesterday = false),
          (this.laterDay = false),
          (this.coment = coment[0]?.comentId);
      } else if (this.showDelete) {
        this.showDelete = false;
      }
    },

    // se abre el formulario de edicion
    async openEdit(item) {
      await autoriz.dispatch("getComent").then(() => {
        this.showAdd = true;
      });

      this.coment = item.comentId;
      if (item.originalFrom < 0) {
        this.yesterday = true;
        registrations.commit("setDateFrom", item.from.slice(1, 6));
      } else {
        this.yesterday = false;
        registrations.commit("setDateFrom", item.from);
      }
      if (item.originalTo > 1440) {
        this.laterDay = true;
        registrations.commit("setDateTo", item.to.slice(1, 6));
      } else {
        this.laterDay = false;
        registrations.commit("setDateTo", item.to);
      }

      this.itemsToEdit = {
        comentId: this.coment,
        empId: item.empId,
        date: item.date,
        desde: item.originalFrom,
      };

      this.titleForm = true;
    },

    //se edita
    edit() {
      if (this.itemsToEdit.comentId !== this.coment) {
        this.itemsToEdit.comentId = this.coment;
      }
      autoriz.commit("setEdit", this.itemsToEdit);
      autoriz
        .dispatch("edit")
        .then((r) => {
          this.textAlert = "Se edito correctamente";
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults");
          this.$store.dispatch("changeSchedule/getScheduleElement");
          autoriz.dispatch("getAutoriz").then(() => {
            this.alertOk = true;
          });
        })
        .catch(() => {
          this.textAlert = this.$tc("alert.errorDelete");
          this.alertError = true;
        });
      this.showAdd = false;
    },

    //se valida el agregar
    validate() {
      let valid = this.$refs.form.validate();
      this.fromValue = this.convertStringInMin(this.from);
      this.toValue = this.convertStringInMin(this.to);

      if (this.laterDay) {
        this.toValue += 1440;
      }
      if (this.yesterday) {
        this.fromValue = this.fromValue - 1440;
      }

      if (valid) {
        if (this.fromValue > this.toValue) {
          this.error = true;
          this.alertValidate = this.$tc("autoriz.greater");
          setTimeout(() => {
            this.error = false;
          }, 3000);
        } else if (this.fromValue < -720) {
          this.error = true;
          this.alertValidate = "No puede superar las 12:00 am del dia anterior";
          setTimeout(() => {
            this.error = false;
          }, 3000);
        } else if (this.toValue > 2160) {
          this.error = true;
          this.alertValidate = "No puede superar las 12:00 am del dia anterior";
          setTimeout(() => {
            this.error = false;
          }, 3000);
        } else {
          if (this.titleForm) {
            this.itemsToEdit = {
              ...this.itemsToEdit,
              timeFrom: this.fromValue,
              timeTo: this.toValue,
            };
            this.edit();
          } else {
            this.addAutoriz();
          }
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    //se agrega una nueva autorizacion
    addAutoriz() {
      let coment = autoriz.state.coment.filter((element) => {
        return element.comentId === this.coment;
      });
      let payload = {
        from: this.fromValue,
        to: this.toValue,
        comentId: this.coment,
        coment: coment[0].coment,
        date: this.date,
        empId: parseInt(localStorage.getItem("empId"), 10),
      };
      autoriz.commit("setNewAutoriz", payload);
      autoriz
        .dispatch("getNewAutoriz")
        .then((r) => {
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults");
          this.$store.dispatch("changeSchedule/getScheduleElement");
          this.textAlert = this.$tc("alert.ok");
          this.alertOk = true;
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = e.response.data.error.message;
        });
      registrations.commit("setDateTo", "12:00");
      registrations.commit("setDateFrom", "06:00");
      this.$refs.form.resetValidation();
      this.from = registrations.state.dateFrom;
      this.to = registrations.state.dateTo;
      this.showAdd = false;
    },

    convertStringInMin(value) {
      let hour = parseInt(value.slice(0, 2), 10);
      let min = parseInt(value.slice(-2), 10);

      let minTotal = hour * 60 + min;
      return minTotal;
    },
  },
};
</script>

<style scoped>
input[type="time"]::-webkit-calendar-picker-indicator {
  background: #90afde !important;
  cursor: pointer !important;
}

.slider__day {
  border: 1px solid #959595;
  border-radius: 5px;
  height: 120px;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.colBtn {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.btn-add {
  background-color: #39537a !important;
  color: white !important;
}

.v-slider__thumb-label p {
  font-size: 9px !important;
}

.v-slider--horizontal .v-slider__track-container {
  height: 5px !important;
  min-width: 160px !important;
}

.slider-icon {
  font-size: 10px !important;
  background: transparent !important;
}

.v-line {
  border-left: thick solid #a8a8a8 !important;
  height: 3% !important;
  left: 50% !important;
  border-radius: 5px !important;
  position: absolute !important;
  margin-top: 15px !important;
  margin-left: 108px !important;
}

.v-line2 {
  border-left: thick solid #a8a8a8 !important;
  border-radius: 5px !important;
  height: 3% !important;
  left: 50% !important;
  position: absolute !important;
  margin-top: 15px !important;
  margin-left: -119px !important;
}

.liner-12 {
  margin-top: -29px !important;
}

.liner-plus12 {
  margin-top: -38px !important;
  display: flex;
  justify-content: flex-end;
}
</style>
